import React, { useState, useEffect, useMemo } from 'react';
import debounce from 'lodash/debounce';
import { SiriusHtmlModal } from '@web-common/components/UI/Modal/SiriusModal';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import styles from './unfinishedDraftMailEntry.module.scss';
import { UnfinishedDrafts } from './UnfinishedDrafts';
import { apiHolder, apis } from 'api';
import { useAppSelector } from '@web-common/state/createStore';
import ErrorBoundary from '@web-common/hooks/ErrorBoundary';
import { ReactComponent as CloseIcon } from '@/images/icons/close_modal.svg';
import { getIn18Text } from 'api';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
import { FLOLDER } from '@web-mail/common/constant';
import { isMainAccount } from '@web-mail/util';
import useCreateCallbackForEvent from '@web-mail/hooks/useCreateCallbackForEvent';
const mailDraftApi = apiHolder.api.requireLogicalApi(apis.mailDraftApiImpl);
const eventApi = apiHolder.api.getEventApi();
const UnfinishedDraftMailEntry = () => {
    const [draftMailVis, setDraftMailVis] = useState(false);
    const [draftMailArr, setDraftMailArr] = useState([]);
    const [selectedKeys] = useState2RM('selectedKeys');
    const edittingMails = useAppSelector(state => state.mailReducer.mails);
    const unfinishedDraftTab = useMemo(() => selectedKeys.id == FLOLDER.DRAFT && isMainAccount(selectedKeys.accountId), [selectedKeys]);
    const edittingCids = useMemo(() => {
        return edittingMails.map(item => item.cid);
    }, [edittingMails.length]);
    const getAllDraftMail = debounce(async () => {
        try {
            const allDraftMail = await mailDraftApi.getAllDraftMail();
            let filtedDraftMail = new Map();
            allDraftMail.forEach((item, key) => {
                if (!edittingCids.includes(key)) {
                    filtedDraftMail.set(key, item);
                }
            });
            const res = [];
            filtedDraftMail.forEach((value, key) => {
                res.push({ cid: key, versions: value });
            });
            setDraftMailArr(res);
        }
        catch (error) {
            console.log('获取邮件草稿失败', error);
        }
    }, 500);
    const delDraftMailByIndex = (index) => {
        try {
            if (draftMailArr === null || draftMailArr === void 0 ? void 0 : draftMailArr.length) {
                const draftArrCopy = JSON.parse(JSON.stringify(draftMailArr));
                draftArrCopy.splice(index, 1);
                setDraftMailArr(draftArrCopy);
                SiriusMessage.success({ content: getIn18Text('YISHANCHU') });
            }
        }
        catch (error) {
            console.log('delDraftMailByIndex error', index, error);
        }
    };
    const clickToView = () => {
        setDraftMailVis(true);
    };
    const closeDraft = () => {
        setDraftMailVis(false);
    };
    const refreshLocalDraft = useCreateCallbackForEvent(() => {
        if (unfinishedDraftTab) {
            getAllDraftMail();
        }
    });
    useEffect(() => {
        if (unfinishedDraftTab) {
            getAllDraftMail();
        }
        else {
            setDraftMailVis(false);
            setDraftMailArr([]);
        }
    }, [unfinishedDraftTab]);
    useEffect(() => {
        const id = eventApi.registerSysEventObserver('refreshLocalDraft', { func: () => refreshLocalDraft() });
        return () => {
            eventApi.unregisterSysEventObserver('refreshLocalDraft', id);
        };
    }, []);
    return (React.createElement(ErrorBoundary, { name: "unfinishedDraftMailEntry" }, unfinishedDraftTab && (draftMailArr === null || draftMailArr === void 0 ? void 0 : draftMailArr.length) > 0 ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.unfinishedDraftMailEntry },
            React.createElement("span", { className: styles.unsaveMail },
                getIn18Text('NINGYOU'),
                React.createElement("span", { className: styles.num },
                    " ",
                    draftMailArr.length || 0,
                    " "),
                getIn18Text('FENGWEIBAOCUN')),
            React.createElement("span", { className: styles.clickToView, onClick: clickToView }, getIn18Text('DIANJICHAKAN'))),
        React.createElement(SiriusHtmlModal, { visible: draftMailVis, width: 580, onCancel: closeDraft, closeIcon: React.createElement(CloseIcon, { className: "dark-invert" }) },
            React.createElement(UnfinishedDrafts, { draftMailArr: draftMailArr, getAllDraftMail: getAllDraftMail, delDraftMailByIndex: delDraftMailByIndex, close: closeDraft })))) : (React.createElement(React.Fragment, null))));
};
export default UnfinishedDraftMailEntry;
